/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconSocialSkype = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M14.754 9.466c.103-.486.158-.991.158-1.509 0-3.884-3.06-7.034-6.836-7.034-.398 0-.789.036-1.169.103A3.864 3.864 0 0 0 4.797.4C2.608.4.832 2.226.832 4.479c0 .753.199 1.458.545 2.063-.091.457-.138.93-.138 1.414 0 3.885 3.061 7.034 6.836 7.034a6.71 6.71 0 0 0 1.252-.118 3.854 3.854 0 0 0 1.874.484c2.19 0 3.964-1.826 3.964-4.079 0-.651-.149-1.266-.412-1.812zm-3.172 1.853c-.316.46-.784.825-1.389 1.084-.6.256-1.318.386-2.136.386-.982 0-1.805-.178-2.448-.529a3.243 3.243 0 0 1-1.126-1.028c-.29-.431-.438-.859-.438-1.271 0-.258.096-.481.285-.664a.989.989 0 0 1 .714-.273c.235 0 .437.073.602.216.157.137.292.341.401.602.121.286.253.526.393.717.134.183.327.336.573.456.248.12.582.182.993.182.565 0 1.028-.124 1.377-.369.341-.239.506-.526.506-.878 0-.278-.086-.496-.264-.667a1.864 1.864 0 0 0-.729-.414c-.311-.1-.733-.207-1.254-.319-.71-.156-1.312-.342-1.792-.552-.49-.215-.885-.512-1.174-.885-.293-.378-.442-.852-.442-1.409 0-.531.156-1.01.464-1.423.306-.41.752-.729 1.327-.948.567-.216 1.242-.325 2.006-.325.61 0 1.147.073 1.595.216.45.144.831.339 1.129.579.301.242.524.5.665.769.142.271.214.541.214.802a.97.97 0 0 1-.281.679.927.927 0 0 1-.702.302c-.253 0-.451-.064-.589-.189-.128-.117-.261-.298-.408-.559a2.325 2.325 0 0 0-.613-.781c-.23-.18-.614-.271-1.141-.271-.49 0-.889.101-1.184.301-.285.193-.424.413-.424.674 0 .16.044.294.136.41.097.122.234.229.408.318.18.093.364.167.55.22.19.054.509.135.946.239a15.63 15.63 0 0 1 1.511.407c.455.15.849.335 1.17.55.327.219.587.501.77.837.185.337.278.754.278 1.239 0 .579-.161 1.107-.478 1.57z"
    />
  </svg>
);

IconSocialSkype.displayName = 'IconSocialSkype';

IconSocialSkype.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconSocialSkype);
IconSocialSkype.displayName = 'IconSocialSkype';
